import { LPBondsCollectionsApi } from 'clientSDK';
import dotenv from 'dotenv';
dotenv.config();

const lpBondsCollectionsApi = new LPBondsCollectionsApi();

export default {
  getCollectionFromAddress: async ({ contractAddress }) => {
    try {
      const responseData = await lpBondsCollectionsApi.getCollectionFromAddress({
        address: contractAddress,
      });
      return responseData;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  getCollectionByBondKey: async ({ bondKey }) => {
    try {
      const responseData = await lpBondsCollectionsApi.getCollectionByBondKey({ bondKey });
      return responseData;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  /**
   * Get lightweight bond routes for navigation
   * Returns only address, route, and chainId - no database queries
   * @returns {Promise<{data: Array<{address: string, route: string, chainId: number}>}>}
   */
  getBondRoutes: async () => {
    try {
      const responseData = await lpBondsCollectionsApi.getBondRoutes();
      return responseData;
    } catch (err) {
      console.error('Error fetching bond routes:', err);
      return { data: [] };
    }
  },

  getPortfolio: async (ownerAddress) => {
    try {
      const responseData = await lpBondsCollectionsApi.getPortfolio(ownerAddress);
      return responseData;
    } catch (err) {
      console.error(err);
      return [];
    }
  },

  getCollectionBidsFromAddress: async ({ address }) => {
    try {
      const responseData = await lpBondsCollectionsApi.getCollectionBidsFromAddress({ address });
      return responseData;
    } catch (err) {
      console.error(err);
      return { bids: [], totalBidVolume: 0 };
    }
  },

  getCollectionHolders: async (address) => {
    try {
      const responseData = await lpBondsCollectionsApi.getCollectionHolders(address);
      return responseData;
    } catch (err) {
      console.error(err);
      return [];
    }
  },

  getCollectionTradingHistory: async (params) => {
    try {
      const responseData = await lpBondsCollectionsApi.getCollectionTradingHistory(params);
      return responseData;
    } catch (err) {
      console.error(err);
      return { data: [] };
    }
  },

  getFavoriteCollections: async (address) => {
    try {
      const responseData = await lpBondsCollectionsApi.getFavoriteCollections(address);
      return responseData;
    } catch (err) {
      console.error(err);
      return { data: [] };
    }
  },

  cancelCollectionBid: async (orderKey) => {
    try {
      const responseData = await lpBondsCollectionsApi.cancelCollectionBid(orderKey);
      return responseData;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  updateMetaStatus: async (contractAddress, metaStatus) => {
    try {
      const responseData = await lpBondsCollectionsApi.updateMetaStatus(
        contractAddress,
        metaStatus,
      );
      return responseData;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  getLaunchpadCollection: async (collectionUrl) => {
    try {
      const responseData = await lpBondsCollectionsApi.getLaunchpadCollection(collectionUrl);
      return responseData;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
};
